module.exports = __webpack_public_path__ + "static/media/12648051_1061103083911113_1462172887_n_edited.6b1f61cd.jpg";